/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SnippetUpdateBodyDoc } from './snippetUpdateBodyDoc';
import type { SnippetUpdateVisibility } from './snippetUpdateVisibility';

export interface SnippetUpdate {
  name?: string | null;
  body_doc?: SnippetUpdateBodyDoc;
  visibility?: SnippetUpdateVisibility;
}
